export const locale = {
  lang: 'fr-CA',
  data: {
    CONVERT_SUBMISSION: {
      TITLE: 'Convertir la soumission',
      DOCUMENT_TYPE: 'Créer',
      TYPE_PROPOSAL: 'Une proposition',
      TYPE_ORDER: 'Une commande',
      GUEST_COUNT: 'Nombre de convives',
      REQUESTED_TIME: 'Heure demandée',
      REQUESTED_GUESTS: 'Convives',
      RESPONSIBLE_EMPLOYEE: 'Conseiller',
      SELECT_RESPONSIBLE_EMPLOYEE: 'Choisir un conseiller',
      RESPONSIBLE_EMPLOYEE_HINT: 'Laisser vide pour vous assigner la soumission.',
      CLIENT: 'Client',
      CLIENT_MATCH: 'Utiliser le client existant trouvé par courriel : ',
      CLIENT_CREATE: 'Créer un nouveau client : ',
      CLIENT_CHOOSE: 'Choisir un autre client',
      SEARCH_CLIENT: 'Rechercher un client',
      NOTE_HINT:
        "Toutes les données du formulaire seront copiées dans la note générale du document créé et la soumission sera archivée, liée au client et à l'événement.",
      CONVERT: 'Convertir',
    },
  },
};
